import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {ErrorSnackBarComponent} from './error-snack-bar/error-snack-bar-component';
import {AuthService} from '../auth.service';
import {catchError} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BusinessErrorDialogService} from './business-error-dialog.service';
import {extractBackendMessage, isBusinessStatus, resolveBusinessMessage} from './business-error-messages';

@Injectable()
export class ManagerHttpInterceptorService implements HttpInterceptor {
    private snackBar!: MatSnackBar;
    private businessErrorDialog!: BusinessErrorDialogService;

    private xCanAccessHeader = 'x-can-access';
    private xExceededMaximumUsersHeader = 'x-exceeded-maximum-users';
    private xBlockAllAccessHeader = 'x-block-all-access';
    private auth!: AuthService;

    constructor(private injector: Injector) {
        this.snackBar = this.injector.get(MatSnackBar);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(err => this.handleError(err, req)));
    }

    private handleError(err: HttpErrorResponse, req: HttpRequest<any>): Observable<never> {
        console.log('p1 - ERROR ' + err.status, req.url);
        if (req.url.toLowerCase().includes('manager-user-access-period-profile/can-access')) {
            console.log('p1 - ERROR can access', req.url);
            return throwError(() => err);
        } else if (err.status === 403 && err.headers.has(this.xCanAccessHeader)) {
            const allowed = JSON.parse(err.headers.get(this.xCanAccessHeader) ?? 'false');
            const timeStart = err.headers.get(this.xCanAccessHeader + '-start');
            const timeEnd = err.headers.get(this.xCanAccessHeader + '-end');
            const timeNow = err.headers.get(this.xCanAccessHeader + '-now');
            if (!this.auth) {
                this.auth = this.injector.get(AuthService);
            }
            this.auth.processCanAccess({allowed: allowed, start: timeStart, end: timeEnd, now: timeNow});
        } else if (err.status === 403 && err.headers.has(this.xExceededMaximumUsersHeader)) {
            const exceededMaximumUsersMessage = err.headers.get(this.xExceededMaximumUsersHeader + '-message');
            const level = err.headers.get(this.xExceededMaximumUsersHeader + '-level');
            if (!this.auth) {
                this.auth = this.injector.get(AuthService);
            }
            const title = level === 'BRANCH'
                ? 'Número máximo de usuários simultâneos da filial atingido.'
                : 'Número máximo de usuários simultâneos da empresa atingido.';
            this.auth.logoutWithTitleAndMessage(title, exceededMaximumUsersMessage ?? '');
        } else if (err.status === 403 && err.headers.has(this.xBlockAllAccessHeader)) {
            const blockAllAccessMessage = err.headers.get(this.xBlockAllAccessHeader + '-message');
            if (!this.auth) {
                this.auth = this.injector.get(AuthService);
            }
            this.auth.logoutWithTitleAndMessage('Acesso temporariamente bloqueado', blockAllAccessMessage ?? '');
        } else if (err.status !== 401) {
            if (this.isSilentError(req)) {
                return throwError(() => err);
            }
            if (!this.isFromIp(req, '127.0.0.1')) {
                if (isBusinessStatus(err.status)) {
                    this.showBusinessError(err);
                } else {
                    this.snackBar.openFromComponent(ErrorSnackBarComponent, {
                        data: {
                            err: err,
                            req: req
                        },
                        duration: 3000
                    });
                }
            }
        }
        return throwError(() => err);
    }

    private showBusinessError(err: HttpErrorResponse): void {
        if (!this.businessErrorDialog) {
            this.businessErrorDialog = this.injector.get(BusinessErrorDialogService);
        }
        const rule = resolveBusinessMessage(err);
        if (rule) {
            this.businessErrorDialog.open(rule.pt);
            return;
        }
        const raw = extractBackendMessage(err);
        this.businessErrorDialog.open(raw || 'Não foi possível concluir a operação.');
    }

    private isSilentError(req: HttpRequest<any>): boolean {
        return req.url.includes('silent-error=1') || req.headers.has('x-silent-error');
    }

    private isFromIp(req: HttpRequest<any>, targetIp: string): boolean {
        try {
            const url = new URL(req.url);
            return url.hostname === targetIp;
        } catch {
            return false;
        }
    }


}
